import { getLang } from "./translator";

export const getCurrentLocaleCode = () => {
  const lang = getLang();

  switch (lang) {
    case "pl":
      return "pl_PL";
    case "en":
    default:
      return "en_US";
  }
};

export const getCustomStrings = (locale) => {
  switch (locale) {
    case "en_US":
      return {
        dropPasteFiles: "Drop files here, paste or %{browseFiles}",
        dropPasteImportFiles:
          "Drop files here, paste, %{browseFiles} or import from:",
      };
    default:
      return {};
  }
};

export const getLocale = (locale) => {
  // eslint-disable-next-line import/no-dynamic-require, global-require
  const data = require(`@uppy/locales/lib/${locale}.js`);
  const customStrings = getCustomStrings(locale);

  return {
    ...data,
    strings: {
      ...data?.strings,
      ...customStrings,
    },
  };
};
